export const headers = ["#", "Document Name", "Document Type", "Actions"];

export const documentKey = "Pre Offer Verification";

export const PREOFFER_VERIFICATION_STAGE_ID = 18;

export const tableData = [
  {
    name: "Conditional Offer Acceptance",
    type: "attachConditionalOfferAcceptance",
  },
  { name: "NRIC/FIN", type: "attachNricFin" },
  { name: "Candidate Consent Form", type: "attachCandidateConsentForm" },
  {
    name: "Management Approval for Avensys EP/Spass/WP",
    type: "attachManagementApprovalForAvensysEpSpassWp",
  },
];
